export default __webpack_public_path__ + "images/fc8922c94a44f28efda337a1f6e73577-vector-cross.svg";